import React, { Fragment } from 'react'
import styled from 'styled-components'
import GlobalSegment from './GlobalSegment'
import footers from '../../../helpers/footers'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #eeeeee;
`
const Header = styled.div`
  display: grid;
  grid-template-columns: 3fr repeat(5, 1fr);
  font-weight: bold;
  padding: 10px 10px 10px 0px;
`
const Year = styled.span`
  text-align: right;
`

export default class Global extends React.Component {
  renderYears = () => {
    const { years } = this.props
    return Array.from(years.keys()).map(year => <Year key={`global-${year}`}>{year}</Year>)
  }
  renderSegments = () => {
    const { years, loan } = this.props
    const { financialReviewSegments, cashflowData } = loan
    return financialReviewSegments.map(segment => {
      const { categories, title } = segment
      return (
        <GlobalSegment
          categories={categories}
          data={cashflowData.filter(datum => categories.map(cat => cat.key).includes(datum.category))}
          years={years}
          title={title}
          key={segment.key}
          loan={loan}
        />
      )
    })
  }
  render() {
    return (
      <Fragment>
        <h3>Global Cash Flow Analysis</h3>
        <Container>
          <Header>
            <div />
            {this.renderYears()}
          </Header>
          {this.renderSegments()}
        </Container>
      </Fragment>
    )
  }
}